import React, {useState} from 'react'
// styles
import './Dashboard.css'

// hooks
import { useCollection } from '../../Hooks/useCollection';
import ProjectList from '../../components/ProjectList/ProjectList';
import ProjectFilters from '../../components/ProjectFilters/ProjectFilters';
import { useAuthContext } from '../../Hooks/useAuthContext';

export default function Dashboard() {
  const { document, error } = useCollection('projects')
  const [currentFilter, setCurrentFilter] = useState('all')

  const { user } = useAuthContext()

  // project filter
  const changeFilter = (newFilter) => {
    
    setCurrentFilter(newFilter)
  }

  const projects = document ? document.filter((docs) => {
    switch(currentFilter){
      // case 'all':
      //   return true
      case 'all': 
        let assignedToMe = false
         docs.assignedUsersList.forEach((u) => {
          if(user.uid === u.id){
            assignedToMe = true
          }
        })
        return assignedToMe
        
      case 'development':
        
      case 'design':
        
      case 'sales':

      case 'finance':
        
      case 'marketing':
        
        let assignedToMeByCategory = false
        // console.log(docs.category, currentFilter)
        docs.assignedUsersList.forEach((u) => {
          if(user.uid === u.id && docs.category === currentFilter){
            assignedToMeByCategory = true
          }
        })
        return assignedToMeByCategory

      default:
        return true;
    } 
  }) : null

  // console.log(projects)

  return (
    <div>
      <h2 className="page-title">Dashboard</h2>
      {document && (
        <ProjectFilters currentFilter={currentFilter} changeFilter={changeFilter}/>
      )}
      {error && <p className="error">{error}</p>}
      {document && <ProjectList projects={projects} />}
    </div>
  )
}
